import { TextField } from 'components/Field/TextField';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import * as React from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { doAuthSetSignInAs } from 'store/actions';
import {
  selectAuthStep,
  selectAuthSignInAs,
  selectAuthStepAs,
  selectUserId,
} from 'store/auth/selectors';
import { AuthenticationSteps } from 'store/auth/types';

export const As: React.FC = () => {
  const authenticationStep = useSelector(selectAuthStep);
  const hasUserId = !!useSelector(selectUserId);
  const canSignInAs = useSelector(selectAuthStepAs);
  const signInAs = useSelector(selectAuthSignInAs);

  const dispatch = useDispatch();

  const hideAbility =
    hasUserId ||
    !canSignInAs ||
    ![AuthenticationSteps.password, AuthenticationSteps.tfa].includes(
      authenticationStep,
    );

  React.useCallback(() => {
    if (hideAbility) {
      dispatch(doAuthSetSignInAs(''));
    }
  }, [hideAbility, dispatch]);

  if (hideAbility) {
    return null;
  }

  return (
    <View
      style={{
        marginTop: theme.padding,
        height: 30,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {!hideAbility && (
        <TextField
          value={signInAs || ''}
          name="as-another-user"
          autoCapitalize="none"
          autoCorrect={false}
          autoComplete="off"
          onChangeWithName={(_: string, value: string) =>
            dispatch(doAuthSetSignInAs(value))
          }
          inputStyle={{
            minHeight: undefined,
            height: 30,
            width: 215,
            textAlign: 'center',
          }}
          containerStyle={{
            width: 215,
            borderRadius: 8,
            overflow: 'hidden',
            opacity: 0.4,
          }}
        />
      )}
    </View>
  );
};
